import React, { useState } from 'react';
import MoreMenu, { ColorPicker, swatch } from './MoreMenu';
import { NameForm } from './TodoSidebar';
import { Icon } from './icons';

/**
 * LABELS, on the Filters & labels page (Oct 2026: labels left the sidebar
 * for More, as Todoist keeps them). Each label with its colour and open
 * count opens what carries it; ☆ pins it to Favourites; ⋯ renames,
 * recolours or deletes it. Before 074 the page is Labels alone.
 */
export default function TodoLabels({ labels, count, busy, actions, onOpen, canPin, isPinned, onPin }) {
  const [adding, setAdding] = useState(false);
  const [renaming, setRenaming] = useState(null);
  return (
    <section className="tdl-labels" aria-labelledby="tdl-labels-h">
      <div className="tdl-head">
        <h3 id="tdl-labels-h" className="tdl-h">Labels</h3>
        <button type="button" className="btn btn-secondary btn-small tdl-new" aria-label="Add label" disabled={busy}
                onClick={() => setAdding(true)}><Icon name="plus" size={14} />New label</button>
      </div>
      {adding && (
        <NameForm label="Name of the new label" placeholder="Label name" withColor
                  onSave={(name, color) => { setAdding(false); actions.addLabel(name, color); }}
                  onCancel={() => setAdding(false)} />
      )}
      {labels.length === 0 && !adding ? (
        <p className="tdl-empty">
          No labels yet. Type <code>@name</code> as you add a to-do, or make one here - a label cuts across every list.
        </p>
      ) : (
        <ul className="tda-nav tda-labels tdl-list" aria-label="Labels">
          {labels.map((b) => (
            <li key={b.id} className="tda-nav-row tdl-row">
              {renaming === b.id ? (
                <NameForm label={`New name for "${b.name}"`} initial={b.name} submit="Save" className="tda-rename-form"
                          onSave={(name) => { setRenaming(null); if (name !== b.name) actions.renameLabel(b, name); }}
                          onCancel={() => setRenaming(null)} />
              ) : (
                <>
                  <button type="button" className="tda-nav-item" data-label={b.id} onClick={() => onOpen(b)}>
                    <span className={`tda-dot is-icon is-tag ${swatch(b.color)}`} aria-hidden="true"><Icon name="tag" /></span>
                    <span className="tda-nav-name">{b.name}</span>
                    <span className="tda-n">{count(b.id) || ''}</span>
                  </button>
                  {canPin && (
                    <button type="button" className={`tda-star${isPinned(b) ? ' is-on' : ''}`} aria-pressed={isPinned(b)}
                            aria-label={isPinned(b) ? `Unpin ${b.name} from Favourites` : `Pin ${b.name} to Favourites`}
                            title={isPinned(b) ? 'In Favourites - unpin' : 'Pin to Favourites'}
                            onClick={() => onPin(b, !isPinned(b))}>
                      <Icon name={isPinned(b) ? 'starFilled' : 'star'} size={14} />
                    </button>
                  )}
                  <MoreMenu label={`More for label "${b.name}"`} disabled={busy} items={[
                    { label: 'Rename', icon: 'edit', onClick: () => setRenaming(b.id) },
                    { label: 'Colour', icon: 'tag', sub: (close) => (
                      <ColorPicker name={b.name} value={b.color} onPick={(c) => { close(); actions.colorLabel(b, c); }} />) },
                    { sep: true },
                    { label: 'Delete…', icon: 'trash', danger: true, onClick: () => actions.deleteLabel(b) }
                  ]} />
                </>
              )}
            </li>
          ))}
        </ul>
      )}
    </section>
  );
}
